import React, { useCallback } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { Modal } from '@vectord/components';
import classNames from 'classnames';

import {
  BLACKLIST_ADD_MODAL_STAGES,
  blacklistedAddMenteeStageSelector,
  setInputErrors,
  setPersonalisedMenteeEmailersAddModalStage,
} from 'features/communicationManagement';
import PersonalisedMenteeEmailersAddModalRenderer from '../PersonalisedMenteeEmailersAddModalRenderer';
import styles from './PersonalisedMenteeEmailersAddModal.module.scss';

export default function PersonalisedMenteeEmailersAddModal() {
  const dispatch = useDispatch();
  const blacklistedAddMenteeStage = useSelector(
    blacklistedAddMenteeStageSelector
  );

  const onCloseModal = useCallback(() => {
    batch(() => {
      dispatch(setInputErrors(null));
      dispatch(
        setPersonalisedMenteeEmailersAddModalStage(
          BLACKLIST_ADD_MODAL_STAGES.close
        )
      );
    });
  }, [dispatch]);

  return (
    <Modal
      className={classNames(styles.manageModalContainer, 'p-xs')}
      isOpen={blacklistedAddMenteeStage !== BLACKLIST_ADD_MODAL_STAGES.close}
      onClose={onCloseModal}
      canClose
      closeOnEscPress={false}
      hasBackdrop
      hasCloseButton={false}
      withoutHeader
      unMountOnClose
    >
      <PersonalisedMenteeEmailersAddModalRenderer />
    </Modal>
  );
}
